var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Modal', {
    attrs: {
      "title": _vm.$t('location_invite.location_added_title')
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function () {
        return [_c('ThemedLoading', {
          attrs: {
            "active": _vm.isLoading,
            "is-full-page": false,
            "opacity": 0.95
          }
        }), _vm.isConfirmed ? _c('div', {
          staticClass: "text-center"
        }, [_c('span', {
          staticClass: "fa-solid fa-house-circle-check fa-4x text-success mb-4"
        }), _c('p', {
          staticClass: "text-success"
        }, [_vm._v(" " + _vm._s(_vm.$t("location_invite.location_added_text", {
          locationName: _vm.location.name
        })) + " ")])]) : _vm.isConfirmed === false ? _c('div', {
          staticClass: "text-center"
        }, [_c('span', {
          staticClass: "fa-solid fa-xmark-circle fa-4x text-danger mb-4"
        }), _c('p', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(_vm.$t("location_invite.error")))])]) : _vm._e(), _c('button', {
          staticClass: "btn btn-block btn-primary",
          on: {
            "click": _vm.onContinue
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("location_invite.continue")) + " ")])];
      },
      proxy: true
    }])
  });

}
var staticRenderFns = []

export { render, staticRenderFns }